module.exports = __webpack_public_path__ + "assets/feature4-4395ae3540f85eca7792f607c15cf2cf.svg";